<template>
	<div style="text-align: center;margin-top: 20px; margin-right: 50px;">

		<el-table v-loading="loading" border :data="tableData" stripe>
			<el-table-column label="id" prop="id" show-overflow-tooltip v-if="false">
			</el-table-column>
			<el-table-column label="标题" prop="title" width="260px" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="提交人" width="200" prop="addId.userDesc" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="处理状态" width="250px" prop="feedFlag" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="处理人" width="200" prop="feedId.userDesc" show-overflow-tooltip>
			</el-table-column>
			<el-table-column label="操作" width="100px">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)">处理</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
		 :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRows">
		</el-pagination>
	</div>
</template>

<script>
	import axios from '@/axios'
	export default {
		data() {
			return {
				show: true,
				tableData: [],
				query: '',
				currentPage: 1,
				totalRows: 0,
				pageSizes: [10, 20, 30, 40],
				pageSize: 10,
				loading: true,
			}
		},
		methods: {
			getTableData() {
				var url = 'framework/SysProblem/queryAll.do'
				var param = {
					page: this.currentPage,
					rows: this.pageSize,
				}
				axios.get(url, param).then(response => {
					if (response.data.code == '0') {
						this.tableData = response.data.data.list
						this.totalRows = response.data.data.total
					} else {
						this.$message({
							type: 'error',
							message: '操作失败!' + response.data.msg
						});
					}
					this.loading = false
				});
			},
			// 修改每页行数
			handleSizeChange(val) {
				this.pageSize = val
				this.getTableData()
			},
			// 修改当前页事件
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData()
			},
			// 查询按钮事件
			search() {
				this.getTableData()
			},
			handleAdd() {
				this.queryPrimaryKey()
			},
			queryPrimaryKey() {
				var url = 'framework/Common/queryPrimaryKey.do'
				var param = {}
				axios.get(url, param).then(response => {
					if (response.data.code == '0') {
						this.gotoDetail(response.data.data)
					} else {
						this.$message({
							type: 'error',
							message: '查询失败' + response.data.msg
						});
					}
				});
			},
			gotoDetail(id) {
				this.$store.commit('setProblemId', id)
				this.$router.push({
					path: '/system/problem/dealdetail',
					meta: {
						keepAlive: false
					}
				})
			},

			handleEdit(row) {
				this.gotoDetail(row.id)
			},
			//开始
			handleDelete(row) {
				this.loading = true
				var url = 'framework/SysProblem/remove.do'
				var param = {
					id: row.id
				}
				axios.post(url, param).then(response => {
					if (response.data.code == '0') {
						this.$message({
							type: 'success',
							message: '操作成功!',
						});
						this.getTableData()
					} else {
						this.$message({
							type: 'error',
							message: '操作失败!' + response.data.msg
						});
					}
					this.loading = false
				});
			},

		},
		mounted() {
			this.getTableData()
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/framework/problem/deallist.vue